import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const submitLead = (data) => axios.post(`${API}/leads`, data);

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password });

export const adminMe = (token) => axios.get(`${API}/auth/me`, authHeader(token));

export const getCharitySummary = () => axios.get(`${API}/charity/summary`);

export const getCharityUpdates = () => axios.get(`${API}/charity/updates`);

export const saveCharitySummary = (token, data) =>
  axios.put(`${API}/charity/summary`, data, authHeader(token));

export const createCharityUpdate = (token, data) =>
  axios.post(`${API}/charity/updates`, data, authHeader(token));

export const deleteCharityUpdate = (token, id) =>
  axios.delete(`${API}/charity/updates/${id}`, authHeader(token));
